import { ERoomsCount, ILayout } from '../../types/newbuilding/layouts';
import { IApplicationState } from '../../types/redux';

export function getCurrentHouse(state: IApplicationState): number {
  return state.layouts?.selectedHouseId || 0;
}

export function getCurrentRoomsCount(state: IApplicationState): ERoomsCount | undefined {
  return state.layouts?.selectedRoomsCount;
}

export function getLayoutsData(state: IApplicationState): ILayout[] {
  return state.layouts?.data || [];
}
